import React from 'react';
import { Eyebrow } from './Eyebrow';
import { SCENES } from '../data/landing';
export function ScenesSection() {
  return <section id="sticky-cta-anchor" className="bg-carbon-3 py-14 md:py-20" aria-labelledby="scenes-title" data-id="element-159" data-mp="3qu0sqc31mor6">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-160" data-mp="3lzwi9iukjylc">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-161" data-mp="3h3o70gjhspjg">
          <Eyebrow tone="dark" data-id="element-162" data-mp="3d1b5637v9bry">¿Te suena familiar?</Eyebrow>
          <h2 id="scenes-title" className="mt-4 text-[26px] leading-[1.15] text-ink-light sm:text-[34px] lg:text-[38px]" data-id="element-163" data-mp="3d2w19x9tx2rx">
            ¿Te reconoces en alguna de estas situaciones?
          </h2>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-164" data-mp="2y420y8xgsdit">
          {SCENES.map((scene, index) => <li key={scene.title} className="rounded-[14px] bg-carbon-card p-5 md:p-6" data-id="element-165" data-mp="11bs47d6rwryy" data-mpi={index}>
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gold/20 text-[10px] font-bold text-gold-light" data-id="element-166" data-mp="wdqj6mpseiku">
                {index + 1}
              </span>
              <h3 className="mt-3 text-[13px] font-bold text-ink-light md:text-[14px]" data-id="element-167" data-mp="1dsh7yj7oq9md">
                {scene.title}
              </h3>
              <p className="mt-2 text-[12px] font-medium leading-relaxed text-ink-light/60 md:text-[13px]" data-id="element-168" data-mp="yw8a9m3g04c2">
                {scene.text}
              </p>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-[16px] font-extrabold tracking-[-0.02em] text-ink-light md:text-[19px]" data-id="element-169" data-mp="1rjunzn6dwpcn">
          La conexión puede ser el comienzo. No tiene por qué ser el final.{' '}
          <span className="text-gold" aria-hidden="true" data-id="element-170" data-mp="1hszzsd9kvfok">
            →
          </span>
        </p>
      </div>
    </section>;
}